import React from 'react';
import { ArrowUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-black text-white py-16 px-4">
      <div className="max-w-[1400px] mx-auto">
        {/* Large Marquee - Let's work together - Faster animation */}
        <div className="mb-20 overflow-hidden">
          <div className="flex animate-marquee-faster whitespace-nowrap">
            <h2 className="text-7xl md:text-9xl lg:text-[140px] font-bold mr-12">
              Let's work together ✱
            </h2>
            <h2 className="text-7xl md:text-9xl lg:text-[140px] font-bold mr-12">
              Let's work together ✱
            </h2>
            <h2 className="text-7xl md:text-9xl lg:text-[140px] font-bold mr-12">
              Let's work together ✱
            </h2>
          </div>
        </div>

        {/* Contact Info Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16 pb-12 border-b border-gray-700">
          <div>
            <h3 className="text-3xl md:text-4xl font-bold mb-4">Jagjot Singh Makkar</h3>
            <p className="text-gray-300 text-sm font-medium">Multi-Disciplinary Digital Creator</p>
          </div>
          <div className="space-y-2 md:text-right">
            <a
              href="mailto:info@jagjotsingh.space"
              className="block text-xl hover:text-orange-500 transition-colors font-medium"
            >
              info@jagjotsingh.space
            </a>
          </div>
        </div>

        {/* Bottom Row */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm font-medium">
            © {new Date().getFullYear()} Jagjot Singh Makkar. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="w-12 h-12 bg-orange-500 hover:bg-orange-600 rounded-full flex items-center justify-center transition-colors duration-300"
            aria-label="Back to top"
          >
            <ArrowUp className="w-5 h-5 text-white" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;